export const getRuntimeVar = (key, defaultValue = "") => {
  // 1. Check if we are in a Browser environment AND if _env_ exists
  if (typeof window !== 'undefined' && window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }

  // 2. Fallback to process.env (Build time / Node.js environment)
  return process.env[`REACT_APP_${key}`] || process.env[key] || defaultValue;
};

// env INVESTIGATIONAL_ONLY
export const getInvestigationOnlyEnvFlag = () => {
  const rawValue = getRuntimeVar(
    'INVESTIGATIONAL_ONLY',
    typeof __INVESTIGATIONAL_ONLY__ !== 'undefined' ? __INVESTIGATIONAL_ONLY__ : false
  );

  // Safely parse it, handling potential uppercase strings like "TRUE"
  if (typeof rawValue === 'string') {
    return rawValue.toLowerCase() === 'true';
  }
  return rawValue === true;
  // return __INVESTIGATIONAL_ONLY__
}

// env GOOGLE_OAUTH_CLIENT_ID
export const getGoogleClientID = () => {
  return getRuntimeVar('GOOGLE_OAUTH_CLIENT_ID', typeof __GOOGLE_OAUTH_CLIENT_ID__ !== 'undefined' ? __GOOGLE_OAUTH_CLIENT_ID__ : false);
  // return __GOOGLE_OAUTH_CLIENT_ID__
}

export const getBuildNo = () => {
  return __BUILDNO__
}

export const getBuildTime = () => {
  return __BUILDTIME__
}

// env NODE_ENV=stagingEU & NODE_ENV=productionEU
export const getIsEU = () => {
  return __STAGINGEU__ || __PRODEU__
}

// env COGNITO_USER_POOL_ID
export const getUserPoolId = () => {
  return getRuntimeVar('COGNITO_USER_POOL_ID', typeof __COGNITO_USER_POOL_ID__ !== 'undefined' ? __COGNITO_USER_POOL_ID__ : false);
  // return __COGNITO_USER_POOL_ID__
}

// env COGNITO_USER_POOL_ID
export const getClientId = () => {
  return getRuntimeVar('COGNITO_CLIENT_ID', typeof __COGNITO_CLIENT_ID__ !== 'undefined' ? __COGNITO_CLIENT_ID__ : false);
  // return __COGNITO_CLIENT_ID__
}

// env AMAZON_REDIRECT_BASE_URL
export const getAmazonRedirectBaseUrl = () => {
  return getRuntimeVar('AMAZON_REDIRECT_BASE_URL', typeof __AMAZON_REDIRECT_BASE_URL__ !== 'undefined' ? __AMAZON_REDIRECT_BASE_URL__ : "");
  // return __AMAZON_REDIRECT_BASE_URL__
}

//env AMAZON_REDIRECT_RESPONSE_TYPE
export const getAmazonRedirectResponseType = () => {
  return getRuntimeVar('AMAZON_REDIRECT_RESPONSE_TYPE', typeof __AMAZON_REDIRECT_RESPONSE_TYPE__ !== 'undefined' ? __AMAZON_REDIRECT_RESPONSE_TYPE__ : "");
  // return __AMAZON_REDIRECT_RESPONSE_TYPE__
}

//env AMAZON_REDIRECT_SCOPE
export const getAmazonRedirectScope = () => {
  return getRuntimeVar('AMAZON_REDIRECT_SCOPE', typeof __AMAZON_REDIRECT_SCOPE__ !== 'undefined' ? __AMAZON_REDIRECT_SCOPE__ : "");
  // return __AMAZON_REDIRECT_SCOPE__
}



// WEBPACK FOOTER //
// ./src/constants/envUtilities.js